<template>
	<div
		:class="['group-operations-popover', isVisible ? 'group-operations-popover-visible' : '']"
	>
		<div class="group-operations-popover-content">
			<Space>
				<div class="pd-lg-right">{{ $t('baseStationGroupActions.title', selectedCount) }}</div>

				<Button
					v-if="validActions.includes('start')"
					class="start-button"
					@click="onStatusChange('start')"
				>
					{{ $t('baseStationActionBar.start') }}
				</Button>

				<Button
					v-if="validActions.includes('stop')"
					@click="onStatusChange('stop')"
				>
					{{ $t('baseStationActionBar.stop') }}
				</Button>

				<Button
					v-if="validActions.includes('enable_vrs')"
					@click="onStatusChange('enable_vrs')"
				>
					{{ $t('baseStationActionBar.enableVrs') }}
				</Button>

				<Button
					v-if="validActions.includes('disable_vrs')"
					@click="onStatusChange('disable_vrs')"
				>
					{{ $t('baseStationActionBar.disableVrs') }}
				</Button>

				<PopconfirmButton
					v-if="validActions.includes('delete')"
					:title="$t('baseStationActionBar.deleteConfirmation')"
					:ok-text="$t('baseStationActionBar.deleteButtonLabel')"
					:cancel-text="$t('baseStationActionBar.cancelButtonLabel')"
					:onConfirm="() => onStatusChange('delete')"
				>
					{{ $t('baseStationActionBar.delete') }}
				</PopconfirmButton>

				<Button
					v-if="validActions.includes('restore')"
					type="primary"
					@click="onStatusChange('restore')"
				>
					{{ $t('baseStationActionBar.restore') }}
				</Button>
			</Space>
		</div>
	</div>
</template>

<script>
import { computed, toRef, watch, ref } from 'vue';
import { Button, Space, message } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import PopconfirmButton from '@/components/common/PopconfirmButton.vue';

import { useBaseStationsStore } from '@/stores/baseStations';

import Consts from '@/api/Consts';


const getValidActions = baseStation => {
	let actions = [];
	if (baseStation.deleted) {
		actions.push('restore');
	}
	else {
		actions.push('delete');
		actions.push(baseStation.include_in_vrs ? 'disable_vrs' : 'enable_vrs');
		if (baseStation.statusData.action === 'stop') {
			actions.push('stop');
		}
		else if (baseStation.statusData.action === 'start') {
			actions.push('start');
		}
	}
	return actions;
};


export default {
	components: {
		Button, Space, PopconfirmButton,
	},
	props: ['baseStations', 'onApply'],
	setup(props) {
		const { t } = useI18n();
		const baseStationsRef = toRef(props, 'baseStations');
		const isVisible = computed(() => baseStationsRef.value.length > 0);

		// нужно, чтобы перед закрытием popover не было смены надписи на 0 выбранных базовых станций. Некрасиво, когда это проскакивает.
		const baseStationsWithDelay = ref(baseStationsRef.value);
		watch(baseStationsRef, value => {
			if (value.length > 0) {
				baseStationsWithDelay.value = value;
			}
		});
		const selectedCount = computed(() => baseStationsWithDelay.value.length);
		const validActions = computed(() => {
			let actions = [];
			baseStationsWithDelay.value.forEach(baseStation => {
				actions = [...actions, ...getValidActions(baseStation)];
			});
			return actions;
		});
		const baseStationsStore = useBaseStationsStore();
		const onStatusChange = action => {
			const ids = baseStationsRef.value.filter(
				baseStation => getValidActions(baseStation).includes(action)
			).map(baseStation => baseStation.id);
			baseStationsStore.changeStatuses(ids, action, () => {
				message.success(t('baseStationActionBar.messages.success'));
			});
			props.onApply();
		};

		return {
			isVisible,
			selectedCount,
			validActions,
			onStatusChange,

			colorSuccess: Consts.COLORS.success,
			colorSuccessLight: Consts.COLORS.successLight,
			colorSuccessUltraLight: Consts.COLORS.successUltraLight,
			colorSuccessUltraDark: Consts.COLORS.successUltraDark,
			colorError: Consts.COLORS.error,
			colorErrorLight: Consts.COLORS.errorLight,
			colorErrorUltraLight: Consts.COLORS.errorUltraLight,
			colorErrorUltraDark: Consts.COLORS.errorUltraDark,

			paddingMd: Consts.CSS.paddingMd,
		};
	}
}
</script>

<style scoped>
.group-operations-popover {
	position: fixed;
	inset-inline-start: 0;
	inset-inline-end: 0;
	bottom: -65px;
	transition: bottom 0.3s cubic-bezier(0.100, 0.485, 0.335, 1.220);
	transition-delay: 0.1s;
}

.group-operations-popover-content {
	margin-inline: auto;
	padding: v-bind(paddingMd);
	background-color: white;
	box-shadow: 0px 2px 12px #777;
	border-radius: 5px;
	width: fit-content;
}

.group-operations-popover-visible {
	bottom: 32px;
	transition-delay: 0s;
}

.start-button {
	background-color: v-bind(colorSuccessUltraLight);
	border-color: v-bind(colorSuccessLight);
	color: v-bind(colorSuccessUltraDark);
}

.start-button:hover,
.start-button:focus {
	background-color: v-bind(colorSuccessLight);
	border-color: v-bind(colorSuccess);
	color: v-bind(colorSuccessUltraDark);
}
</style>